import { FC, useContext, useMemo } from "react";
import { useTranslation } from "react-i18next";

import { MuiButton } from "@ryde/controls";

import { useDashboardViews } from "../../hooks/use-dashboard-views";
import { DashboardViewContext } from "./dashboard-view.context";

export const DashboardSaveViewButton: FC = () => {
  const { t } = useTranslation();
  const { views, activeViewId } = useDashboardViews();
  const { openEditView } = useContext(DashboardViewContext);

  const activeView = useMemo(
    () => views.find(view => view.id === activeViewId),
    [views, activeViewId],
  );

  const onClickHandler = (): void => {
    openEditView();
  };

  return (
    <MuiButton
      title={activeView?.name || t("view.create")}
      e2eData="save-view-button"
      muiVariant="outlined"
      muiStyle={"secondary"}
      onClick={onClickHandler}
      sx={{ flexShrink: 0, width: "107px" }}
    >
      {t(`view.create`)}
    </MuiButton>
  );
};
